import { UI, VStack } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import React, { useEffect, useState } from 'react';

import { UserSelectionsProps } from '../..';
import { InputMoney } from '../../../../../../../../../../../../components/InputMoney';
import { InputPercentage } from '../../../../../../../../../../../../components/InputPercentage';
import { usePublicOfferAssetRemunerationController } from '../../../../../../../../../../../BatchTicket/components/DynamicAsset/hooks/products/PublicOffer';

export interface PublicOfferRemunerationFieldsProps extends Required<UserSelectionsProps> {}

export const PublicOfferRemunerationFields: React.FC<PublicOfferRemunerationFieldsProps> = ({
  offer,
  offerDetails,
  selectedModality,
  setUserSelectionValues,
}) => {
  const [useMarketValue, setUseMarketValue] = useState(false);
  const id = offer.offerId;

  const {
    control,
    currentValue,
    currentValueFormatted,
    currentRemuneration,
    currentRemunerationFormatted,
    minimumValue,
    minimumRemuneration,
    handleInputValueBlur,
    handleInputValueClear,
    handleInputValueFocus,
    handleInputRemunerationBlur,
    handleInputRemunerationClear,
    handleInputRemunerationFocus,
    handleSubmit,
    hasErrorValue,
    hasErrorRemuneration,
    isValueFocused,
    isRemunerationFocused,
    minMaxValueDescription,
  } = usePublicOfferAssetRemunerationController(offer, offerDetails, selectedModality);

  useEffect(() => {
    setUserSelectionValues((prev) => ({
      ...prev,
      useMarketValueRemuneration: useMarketValue,
      currentRemuneration: useMarketValue ? undefined : currentRemuneration,
      currentValue,
      hasError: !!hasErrorValue || !!hasErrorRemuneration,
    }));
  }, [
    currentRemuneration,
    currentValue,
    useMarketValue,
    id,
    hasErrorValue,
    hasErrorRemuneration,
    setUserSelectionValues,
  ]);

  return (
    <VStack space="stack.xxxs">
      <VStack space="stack.quarck">
        <UI.Text color="neutral.black" variant="semibold">
          Valor desejado
        </UI.Text>

        <InputMoney
          id={`public-offer-value-input${id}`}
          name="priceItem"
          control={control}
          handleFocus={handleInputValueFocus}
          handleBlur={handleInputValueBlur}
          handleSubmit={handleSubmit}
          handleClear={handleInputValueClear}
          currentValue={currentValueFormatted}
          hasFocus={isValueFocused}
          minValue={minimumValue}
          customInputProps={{
            ...{ ...(isValueFocused && hasErrorValue && { error: hasErrorValue }) },
          }}
        />
      </VStack>
      <VStack space="stack.quarck">
        <UI.Text color="neutral.black" variant="semibold">
          Remuneração mínima
        </UI.Text>

        <InputPercentage
          isDisabled={useMarketValue}
          customPressableProps={{
            ...{ ...(useMarketValue && { bg: 'neutral.lightest', color: 'neutral.light' }) },
          }}
          id={`public-offer-remuneration-input${id}`}
          name="remuneration"
          control={control}
          handleFocus={handleInputRemunerationFocus}
          handleBlur={handleInputRemunerationBlur}
          handleSubmit={handleSubmit}
          handleClear={handleInputRemunerationClear}
          currentValue={currentRemunerationFormatted}
          hasFocus={isRemunerationFocused}
          minValue={minimumRemuneration}
          customInputProps={{
            ...{
              ...(isRemunerationFocused && hasErrorRemuneration && { error: hasErrorRemuneration }),
            },
          }}
        />
      </VStack>
      <UI.Text color="neutral.dark" fontSize={Typography['fontsize.xs']}>
        {minMaxValueDescription}
      </UI.Text>
      <UI.Checkbox
        testId={`second-copy-checkbox-${id}`}
        onChange={() => setUseMarketValue((prev) => !prev)}
        options={[{ label: 'A mercado', value: 'useMarketValue' }]}
        selectedValues={useMarketValue ? ['useMarketValue'] : []}
        optionPadding={{ bottom: 0, right: 0 }}
      />
    </VStack>
  );
};
